import React from "react";

interface ChartCardProps {
  title: string;
  description: string;
  headerIcon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const ChartCard = ({
  title,
  description,
  children,
  className = "",
  headerIcon = null,
}: ChartCardProps) => (
  <div
    className={`bg-popper-bg dark:bg-popper-bg-dk border border-border-gray dark:border-border-gray-dk rounded-[8px] pt-4 px-4 flex flex-col gap-3 min-w-0 ${className}`}
  >
    <div>
      <div className="flex gap-1 items-center">
        {headerIcon}
        <span className="text-base font-medium text-heading-text dark:text-heading-text-dk">
          {title}
        </span>
      </div>
      <p className="text-xs text-dark-gray dark:text-dark-gray-dk mt-0.5">
        {description}
      </p>
    </div>
    {children}
  </div>
);

export const ChartEmptyState = ({ height = "h-[200px]" }: { height?: string }) => (
  <div className={`${height} flex flex-col items-center justify-center gap-3 opacity-60`}>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className="text-dark-gray dark:text-dark-gray-dk"
    >
      <rect x="6" y="30" width="8" height="12" rx="2" fill="currentColor" opacity="0.25" />
      <rect x="20" y="20" width="8" height="22" rx="2" fill="currentColor" opacity="0.4" />
      <rect x="34" y="10" width="8" height="32" rx="2" fill="currentColor" opacity="0.25" />
      <line x1="4" y1="44" x2="44" y2="44" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.3" />
    </svg>
    <p className="text-sm text-dark-gray dark:text-dark-gray-dk">
      No data available
    </p>
  </div>
);

export default ChartCard;
